export const GRAMMAR_CLIP_SOURCES = ['manual', 'mined'] as const;
